<input type="text" [attr.class]="cssClass" placeholder="{{placeholder}}" [minDate]="minDate" [maxDate]="maxDate" [bsConfig]="dpConfig" #drp="bsDaterangepicker"
  bsDaterangepicker (bsValueChange)="onBsValueChange($event)">
